var Decimal = require('decimal.js-light')

/**
 * Subtract b from a using Decimal arithmetic to avoid floating-point drift.
 * Treats null/undefined as 0. Returns a plain JS Number.
 */
export function subtract (a, b) {
  return new Decimal(a || 0).minus(b || 0).toNumber()
}

/**
 * Sum all numbers in arr using Decimal arithmetic.
 * Treats null/undefined entries as 0. Returns a plain JS Number.
 */
export function sumReduce (arr) {
  return (arr || []).reduce(function (sum, n) {
    return new Decimal(sum).plus(n || 0).toNumber()
  }, 0)
}

/**
 * Return the smaller of a and b using Decimal comparison.
 * Treats null/undefined as 0. Returns a plain JS Number.
 */
export function min (a, b) {
  var da = new Decimal(a || 0)
  var db = new Decimal(b || 0)
  return da.lte(db) ? (a || 0) : (b || 0)
}
